
import './index.css';

import React, { useEffect, useState } from 'react';

import StatusBadge from '../../ui/StatusBadge';
import RecordSection from '../RecordSection';
import SubRecordModal from '../../ui/SubRecordModal';




import Factory from '../../../records/modules';

const TASK_STATUS_OPTIONS = [
  { value: 'todo', label: 'To Do' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'done', label: 'Done' },
  { value: 'blocked', label: 'Blocked' },
];

const EMPTY_TASK = { title: '', description: '', status: 'todo', dueDate: '', weeklyUpdateId: '' };

function Tasks({ meta, domain, parentId }) {
  const [weeklyUpdates, setWeeklyUpdates] = useState(domain.weeklyUpdates || []);
  const [tasks, setTasks] = useState(domain.tasks || []);

  const [taskModal, setTaskModal] = useState({ open: false, editing: null, form: EMPTY_TASK, submitting: false, error: '' });

  useEffect(() => {
    setTasks(domain.tasks || []);
  }, [domain.tasks]);

  useEffect(() => {
    setWeeklyUpdates(domain.weeklyUpdates || []);
  }, [domain.weeklyUpdates]);

  function openAddTask() {
    setTaskModal({ open: true, editing: null, form: EMPTY_TASK, submitting: false, error: '' });
  }

  function openEditTask(task) {
    setTaskModal({
      open: true,
      editing: task,
      form: {
        title: task.title || '',
        description: task.description || '',
        status: task.status || 'todo',
        dueDate: task.dueDate || '',
        weeklyUpdateId: task.weeklyUpdateId || '',
      },
      submitting: false,
      error: '',
    });
  }

  function closeTaskModal() {
    setTaskModal((s) => ({ ...s, open: false }));
  }

  function setTaskField(field, value) {
    setTaskModal((s) => ({ ...s, form: { ...s.form, [field]: value } }));
  }

  async function submitTask() {
    setTaskModal((s) => ({ ...s, submitting: true, error: '' }));
    try {
      const payload = {
        title: taskModal.form.title.trim(),
        description: taskModal.form.description.trim() || null,
        status: taskModal.form.status,
        dueDate: taskModal.form.dueDate || null,
        weeklyUpdateId: taskModal.form.weeklyUpdateId || null,
      };
      if (taskModal.editing) {
        const updated = await Factory({ slug: meta.slug }).Data.updateRecord(taskModal.editing.id, payload);
        setTasks((current) => current.map((item) => (
          item.data.id === updated.id ? { data: updated } : item
        )));
      } else {
        const created = await Factory({ slug: meta.slug }).Data.createRecord({
          ...payload,
          [meta.parentId]: parentId,
        });
        setTasks((current) => [...current, { data: created }]);
      }
      closeTaskModal();
    } catch (err) {
      const message = err?.response?.data?.message || 'Unable to save task.';
      setTaskModal((s) => ({ ...s, submitting: false, error: message }));
    }
  }

  async function handleDeleteTask(task) {
    if (!window.confirm(`Delete task "${task.title}"? This cannot be undone.`)) return;
    try {
      await Factory({ slug: meta.slug }).Data.deleteRecord(task.id);
      setTasks((current) => current.filter((item) => item.data.id !== task.id));
    } catch (err) {
      alert(err?.response?.data?.message || 'Unable to delete task.');
    }
  }


  return (
    <>
      <RecordSection
        title="Tasks"
        className="record-tasks"
        actions={(
          <button className="button-secondary" onClick={openAddTask} type="button">
            + Add Task
          </button>
        )}
      >
        {tasks.length === 0 ? (
          <p>No tasks yet.</p>
        ) : (
          <table className="data-table">
            <thead>
              <tr>
                <th>Task</th>
                <th>Status</th>
                <th>Due Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {tasks.map((task) => (
                <tr key={task.data.id}>
                  <td>{task.data.title}</td>
                  <td><StatusBadge value={task.data.status} /></td>
                  <td>{task.data.dueDate || '-'}</td>
                  <td>
                    <div className="sub-record-row-actions">
                      <button className="button-row-edit" onClick={() => openEditTask(task.data)} type="button">Edit</button>
                      <button className="button-row-delete" onClick={() => handleDeleteTask(task.data)} type="button">Delete</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </RecordSection>


      {/* Task modal */}
      <SubRecordModal
        error={taskModal.error}
        isOpen={taskModal.open}
        isSubmitting={taskModal.submitting}
        onClose={closeTaskModal}
        onSubmit={submitTask}
        submitLabel={taskModal.editing ? 'Save Changes' : 'Add Task'}
        title={taskModal.editing ? 'Edit Task' : 'Add Task'}
      >
        <div className="form-grid">
          <label>
            Title <span aria-hidden="true">*</span>
            <input
              autoFocus
              onChange={(e) => setTaskField('title', e.target.value)}
              placeholder="Task title"
              required
              type="text"
              value={taskModal.form.title}
            />
          </label>
          <label>
            Description
            <textarea
              onChange={(e) => setTaskField('description', e.target.value)}
              placeholder="Optional details"
              value={taskModal.form.description}
            />
          </label>
          <div className="form-grid two-col">
            <label>
              Status
              <select onChange={(e) => setTaskField('status', e.target.value)} value={taskModal.form.status}>
                {TASK_STATUS_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </label>
            <label>
              Due Date
              <input
                onChange={(e) => setTaskField('dueDate', e.target.value)}
                type="date"
                value={taskModal.form.dueDate}
              />
            </label>
          </div>
          {weeklyUpdates.length > 0 && (
            <label>
              Link to Weekly Update (optional)
              <select onChange={(e) => setTaskField('weeklyUpdateId', e.target.value)} value={taskModal.form.weeklyUpdateId}>
                <option value="">— None —</option>
                {weeklyUpdates.map((w) => (
                  <option key={w.data.id} value={w.data.id}>Week of {w.data.weekStart}</option>
                ))}
              </select>
            </label>
          )}
        </div>
      </SubRecordModal>
    </>
  );
}

export default Tasks;